export default "__VITE_ASSET__CiYmPBKa__"